export const StarIcon = (): JSX.Element => (
  <>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.734 16">
      <path
        strokeLinejoin="round"
        strokeWidth="1.22198"
        d="M15.273 5.56l-4.371-.38-1.707-4.02c-.312-.732-1.351-.732-1.663 0L5.827 5.19l-4.362.369C.669 5.625.345 6.617.95 7.139l3.314 2.872-.993 4.264c-.184.778.663 1.392 1.345.975l3.748-2.258 3.748 2.267c.683.417 1.53-.197 1.346-.975l-.993-4.272 3.314-2.872c.61-.517.29-1.513-.506-1.58z"
      />
    </svg>
  </>
);
